import {
    DeserializeCallbackFunc,
    DeserializerFunc1,
    IDeserializeContext,
    IPropSchema
} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';
import {_defaultPrimitiveProp} from '../constants';
import {invariant, isAliasedPropSchema, isPropSchema} from '../utils/utils';

/**
 * Optional indicates that this property can be null.
 * Accepts a sub model schema to serialize the contents
 *
 * @example
 * class SubTask {}
 * class Task {}
 * class Todo {}
 *
 * createModelSchema(SubTask, {
 *     title: true,
 * });
 * createModelSchema(Todo, {
 *     title: true,
 *     subTask: optional(object(SubTask)),
 * });
 *
 * const todo = deserialize(Todo, {
 *     title: 'Task',
 *     subTask: null
 * });
 *
 * @param {IPropSchema} propSchema to be used to (de)serialize the content
 * @returns {IPropSchema}
 */
export function optional(propSchema:IPropSchema):IPropSchema
{
    propSchema = propSchema || _defaultPrimitiveProp;

    invariant(isPropSchema(propSchema), 'expected prop schema as first argument');
    invariant(!isAliasedPropSchema(propSchema), 'provided prop is aliased, please put aliases first');

    return {
        serializer: function(value:any, key:string | number, source:any, baseValue:any):any
        {
            return value != null ? propSchema.serializer(value, key, source, baseValue) : null;
        },
        deserializer: function(jsonValue:any, done:DeserializeCallbackFunc, context:IDeserializeContext, currentPropertyValue:any, baseValue:any):void
        {
            if( jsonValue == null )
                done(null, null);
            else
                (propSchema.deserializer as DeserializerFunc1)(jsonValue, done, context, currentPropertyValue, baseValue);
        }
    };
}
